import React from 'react';
import Grid from '../../common/Grid/Grid';
import MyAssignmentCardItem from './MyAssignmentCardItem';

/**
 * MyAssignmentsGrid - Virtualized grid for displaying assignment cards
 * Uses the shared Grid component with react-window for performance
 */
const MyAssignmentsGrid = ({
  assignments,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  employeeId,
  hasFiltersApplied,
  captureScrollState,
  setLastViewedAssignmentId,
}) => {
  const renderAssignmentItem = ({ item, onClick }) => {
    // Capture scroll state for this specific item
    const scrollState = captureScrollState ? captureScrollState(item) : null;

    return (
      <MyAssignmentCardItem
        assignment={item}
        employeeId={employeeId}
        onClick={() => onClick(item)}
        scrollState={scrollState}
        setLastViewedAssignmentId={setLastViewedAssignmentId}
      />
    );
  };

  // Dynamic empty state description based on filters
  const emptyStateDescription = hasFiltersApplied
    ? "No assignments match your filter criteria. Try adjusting your filters."
    : "You don't have any assignments yet.";

  return (
    <Grid
      items={assignments}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderAssignmentItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No Assignments Found"
      emptyStateDescription={emptyStateDescription}
      endOfListMessage="You've reached the end of the list"
      rowHeight={650}
    />
  );
};

export default MyAssignmentsGrid;
